import Header from '../components/Header';
import Footer from '../components/Footer';
import { Cookie, Settings } from 'lucide-react';

const CookiePolicy = () => {
  const currentDate = new Date().toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <div className="min-h-screen">
      <Header />
      <div className="pt-32 pb-20 px-4">
        <div className="container mx-auto max-w-4xl">
          <article className="glass-strong rounded-3xl p-8 md:p-12">
            <div className="flex items-center space-x-3 mb-8">
              <Cookie className="w-8 h-8 text-green-600" />
              <h1 className="pb-2 text-4xl md:text-5xl font-bold bg-gradient-to-r from-pink-600 to-green-600 bg-clip-text text-transparent">
                Cookie Policy
              </h1>
            </div>

            <div className="mb-6 text-sm text-gray-600">
              <p>Last Updated: {currentDate}</p>
            </div>

            <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-6">
              <p className="text-xl text-gray-800 font-medium">
                This Cookie Policy explains how Crown Jackpot uses cookies and similar tracking technologies when you visit our website crown-jackpot.com. This policy should be read alongside our Privacy Policy, which provides additional information about how we collect, use, and protect your personal information.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mt-8 mb-4">What Are Cookies?</h2>

              <p>
                Cookies are small text files that are placed on your device (computer, tablet, or mobile phone) when you visit a website. Cookies allow websites to recognize your device and store some information about your preferences or past actions. They help websites work more efficiently and provide information to website owners about how their site is being used.
              </p>

              <p>
                We use both "session cookies," which are temporary and deleted when you close your browser, and "persistent cookies," which remain on your device for a set period or until you delete them. We also use similar technologies such as web beacons, pixel tags, and local storage, which function similarly to cookies.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mt-8 mb-4">Types of Cookies We Use</h2>

              <h3 className="text-2xl font-bold text-gray-800 mt-6 mb-3">Essential Cookies</h3>
              <p>
                These cookies are necessary for the website to function properly and cannot be switched off. They are usually set in response to actions you take, such as setting privacy preferences, logging in, or filling in forms. Essential cookies enable core functionality such as security, network management, and accessibility.
              </p>

              <h3 className="text-2xl font-bold text-gray-800 mt-6 mb-3">Analytics and Performance Cookies</h3>
              <p>
                These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. They allow us to count visits, identify traffic sources, and understand which pages are most popular. This information helps us improve how our website works and provides better user experiences.
              </p>

              <h3 className="text-2xl font-bold text-gray-800 mt-6 mb-3">Functionality Cookies</h3>
              <p>
                These cookies enable enhanced functionality and personalization, such as remembering your preferences, language selection, or region. They may be set by us or by third-party providers whose services we have added to our pages. If you do not allow these cookies, some features may not function properly.
              </p>

              <h3 className="text-2xl font-bold text-gray-800 mt-6 mb-3">Targeting and Advertising Cookies</h3>
              <p>
                These cookies may be set through our site by our advertising partners to build a profile of your interests and show you relevant content on other sites. They work by uniquely identifying your browser and device. If you do not allow these cookies, you will experience less targeted advertising.
              </p>

              <div className="glass p-6 rounded-2xl my-8 border-l-4 border-green-500">
                <div className="flex items-start space-x-3">
                  <Settings className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-gray-800 mb-2">Cookie Management</h3>
                    <p className="text-gray-700">
                      You can control and manage cookies through your browser settings. Most browsers allow you to refuse cookies, delete cookies, or receive a warning before a cookie is stored. However, disabling certain cookies may affect website functionality and your user experience.
                    </p>
                  </div>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-gray-800 mt-8 mb-4">Third-Party Cookies</h2>

              <p>
                In addition to our own cookies, we may use various third-party cookies to report usage statistics, deliver advertisements, and provide enhanced functionality. These third-party cookies are set by domains other than crown-jackpot.com and are subject to the privacy policies of those third parties.
              </p>

              <p>
                We use Google Analytics to analyze website usage. Google Analytics uses cookies to collect information about how visitors use our website. This information is used to compile reports and help us improve the site. For more information about Google Analytics cookies, visit Google's privacy policy.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mt-8 mb-4">How to Manage Cookies</h2>

              <p>
                You have the right to accept or reject cookies. Most web browsers automatically accept cookies, but you can usually modify your browser settings to decline cookies if you prefer. However, this may prevent you from taking full advantage of the website's features.
              </p>

              <p>
                To manage cookies in your browser:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li><strong>Chrome:</strong> Settings &gt; Privacy and Security &gt; Cookies and other site data</li>
                <li><strong>Firefox:</strong> Options &gt; Privacy &amp; Security &gt; Cookies and Site Data</li>
                <li><strong>Safari:</strong> Preferences &gt; Privacy &gt; Cookies and website data</li>
                <li><strong>Edge:</strong> Settings &gt; Privacy, search, and services &gt; Cookies and site permissions</li>
              </ul>

              <h2 className="text-3xl font-bold text-gray-800 mt-8 mb-4">Do Not Track Signals</h2>

              <p>
                Some browsers include a "Do Not Track" (DNT) feature that signals to websites you visit that you do not want to have your online activity tracked. Currently, there is no standard for how DNT signals should be interpreted. As a result, our website does not currently respond to DNT browser signals or mechanisms.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mt-8 mb-4">Cookie Consent</h2>

              <p>
                When you first visit our website, we may display a cookie consent banner that allows you to accept or reject non-essential cookies. You can change your cookie preferences at any time by accessing our cookie settings or by modifying your browser settings as described above.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mt-8 mb-4">Updates to This Policy</h2>

              <p>
                We may update this Cookie Policy from time to time to reflect changes in our practices, technology, or legal requirements. We will notify you of any material changes by posting the updated policy on this page and updating the "Last Updated" date. We encourage you to review this Cookie Policy periodically.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mt-8 mb-4">Contact Us</h2>

              <p>
                If you have questions about our use of cookies or this Cookie Policy, please contact us at:
              </p>

              <div className="glass p-6 rounded-2xl my-6">
                <p className="font-semibold text-gray-800 mb-2">Crown Jackpot</p>
                <p className="text-gray-700">Email: info@crown-jackpot.com</p>
                <p className="text-gray-700">Phone: +44 9296 526 586</p>
                <p className="text-gray-700">Address: London, United Kingdom</p>
              </div>
            </div>
          </article>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CookiePolicy;

